document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper', {
    grabCursor: true,
    spaceBetween: 8,
    slidesPerView: 2.2,
    autoHeight: true,
    spaceBetween: 12,
    centerInsufficientSlides: true,
    breakpoints: {
      1280: {
        slidesPerView: 6.2,
      }
    },
    mousewheel: {
      forceToAxis: true,
    },
    on: {
      init: function () {
        document.querySelector('.image-anchor-carousel-swiper-before-init').classList.remove('image-anchor-carousel-swiper-before-init');
      }
    }
  });
});
